//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
import searchUtils from '~/mixins/search/search-utils'
import BoatCard from '~/components/Boats/card/boat-card.vue'
import BoatCardSkeleton from '~/components/Boats/card/boat-card-skeleton.vue'
import BnrSpring from '~/components/banners/bnrSpring.vue'
import PaginationComponent from '~/components/global/PaginationComponent.vue'
import BnrShipmate from '~/components/search/bnr-shipmate.vue'
import SearchNoResults from '~/components/search/search-no-results.vue'

export default {
  name: 'SearchResults',
  components: {
    SearchNoResults,
    BnrShipmate,
    PaginationComponent,
    BnrSpring,
    BoatCardSkeleton,
    BoatCard
  },
  mixins: [searchUtils],
  props: {
    withPagination: {
      type: Boolean,
      default: true
    },
    resultsFilterFunction: {
      type: Function,
      default: i => i
    }
  },
  computed: {
    ...mapGetters({
      userCredits: 'auth/userCredits'
    }),
    getSearchRoute () {
      return this.$Search.generateClientUrl()
    },
    getPaginateParams () {
      return this.$router.resolve(this.getSearchRoute).href?.split('?')?.[0]
    },
    getPaginateQuery () {
      return this.$router.resolve(this.getSearchRoute).href?.split('?')?.[1]
    }
  }
}
